// bootstrap
import { Tooltip } from "react-bootstrap";

// TOOLTIPS
// delete
export const renderTooltipDelete = (props) => (
    <Tooltip {...props}>Delete Order</Tooltip>
);

// edit
export const renderTooltipEdit = (props) => (
    <Tooltip {...props}>Edit Order</Tooltip>
);

// view
export const renderTooltipView = (props) => (
    <Tooltip {...props}>View</Tooltip>
);
